import type { NavParams, Page, UserRole } from '@types';
import { canManageClientAccount } from './clientAccountAccess';

const LMS_ROLES = new Set<UserRole>(['owner', 'admin', 'trainer', 'learner']);
const ADMIN_ROLES = new Set<UserRole>(['owner', 'admin']);
const PUBLIC_PAGES = new Set<Page>([
    'marketing',
    'branding',
    'auth',
    'contact',
    'terms-of-service',
    'privacy-policy',
    'data-and-ai-policy',
    'legal-disclaimer',
    'subscription-agreement',
    'refund-policy',
    'cancellation-policy',
    'pending_clearance',
]);
const READ_ONLY_REPORT_PAGES = new Set<Page>([
    'analysisDisplay',
    'CountryAnalysisResults',
    'OSINTDossierResults',
    'executiveReport',
    'GovernanceStructure',
    'reportLibrary',
    'deliveredReport',
]);

export const canUseLms = (role?: UserRole) => !!role && LMS_ROLES.has(role);
export const canUseServiceRequests = (role?: UserRole, serviceRequestAccess = false) => !!role && (ADMIN_ROLES.has(role) || role === 'service_requester' || role === 'service_requestor' || serviceRequestAccess);

export const isDirectClientRouteAllowed = (page: Page, params: NavParams = {}, role?: UserRole, serviceRequestAccess = false) => {
    if (PUBLIC_PAGES.has(page) || READ_ONLY_REPORT_PAGES.has(page))
        return true;
    if (page === 'organizationDashboard' || page === 'help' || page === 'global_risk_register')
        return true;
    if (page === 'subscriptionManagement')
        return canManageClientAccount(role);
    if (page === 'myAccount')
        return canManageClientAccount(role);
    if (page === 'serviceRequests')
        return canUseServiceRequests(role, serviceRequestAccess);
    if (page === 'srm_command_center')
        return Boolean(params.projectId);
    if (page === 'suiteDashboard')
        return canUseLms(role) && params.suiteName === 'Learning Management Suite (LMS)';
    if (page === 'training')
        return canUseLms(role);
    return false;
};
